import { render } from "./UserBoard.vue?vue&type=template&id=0a49a6a5"
import script from "./UserBoard.vue?vue&type=script&lang=js"
export * from "./UserBoard.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__